import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { ModalConfig, ModalSizes, ModalVariants } from './modal-config';
import { FcpModalService } from './fcp-modal.service';

@Component({
    selector: 'fcp-modal',
    templateUrl: './fcp-modal.component.html',
    styleUrls: ['./fcp-modal.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FcpModalComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() readonly id?: string;
    @Input() title: string;
    @Input() config?: ModalConfig;
    @Input() template: TemplateRef<any>;
    @Input() size: ModalSizes = ModalSizes.Medium;
    @Input() variant: ModalVariants = ModalVariants.Passive;
    @Input() showCloseIcon = true;

    @Output() onBack = new EventEmitter();

    @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

    public modalConfig: ModalConfig;

    constructor(private fcpModalService: FcpModalService) {}

    ngOnInit(): void {
        const defaultConfig: ModalConfig = {
            id: this.id,
            title: this.title,
            variant: this.variant,
            size: this.size,
            data: {},
            hasBackdrop: true,
            disableClose: false,
            closeOnNavigation: true,
            backdropClass: 'fcp-modal-backdrop',
            autoFocus: false,
            hasBackButton: false,
            mobileAutoScale: false,
            withoutContentPadding: false
        };

        this.modalConfig = {
            ...defaultConfig,
            ...this.config
        };
    }

    ngAfterViewInit(): void {
        this.modalConfig.data.template = this.modalTemplate;
        this.fcpModalService.add(this.modalConfig);
    }

    ngOnDestroy(): void {
        this.fcpModalService.remove(this.modalConfig.id);
    }

    /* Alternative method to set height for mobile. Makes sure content doesn't overlap with iOS navigation bars */
    public getDynamicHeight() {
        const { mobileAutoScale, size } = this.modalConfig;

        if (mobileAutoScale && size === ModalSizes.Mobile) {
            return `height: ${window.innerHeight}px`;
        }

        return '';
    }

    public close() {
        this.fcpModalService.close(this.modalConfig.id);
    }

    public back() {
        this.onBack.emit();
    }
}
